import { FC, SVGProps } from 'react'

export const IconCalculator2: FC<SVGProps<SVGSVGElement>> = ({
  id,
  ...props
}) => {
  const filter0 = `${id}-filter0`
  return (
    <svg
      width="32"
      height="36"
      viewBox="0 0 32 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter={`url(#${filter0})`}>
        <rect
          x="9"
          y="9.00488"
          width="14"
          height="17.5"
          rx="4"
          stroke="#C8F252"
          strokeWidth="1.2"
        />
        <rect
          x="12.5"
          y="12.5049"
          width="7"
          height="2.625"
          rx="1"
          stroke="#C8F252"
          strokeWidth="1.2"
        />
        <path
          d="M13.375 23.0049H12.5"
          stroke="#C8F252"
          strokeWidth="1.2"
          strokeLinecap="round"
        />
        <path
          d="M13.375 19.5049H12.5"
          stroke="#C8F252"
          strokeWidth="1.2"
          strokeLinecap="round"
        />
        <path
          d="M18.625 23.0049H19.5"
          stroke="#C8F252"
          strokeWidth="1.2"
          strokeLinecap="round"
        />
        <path
          d="M18.625 19.5049L19.5 19.5049"
          stroke="#C8F252"
          strokeWidth="1.2"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <filter
          id={filter0}
          x="-4"
          y="-1.99512"
          width="40"
          height="40"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="4" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.784314 0 0 0 0 0.94902 0 0 0 0 0.321569 0 0 0 0.6 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_6773_115982"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_6773_115982"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}
